// Geometría de las formas — compartida por el preview (LayerView, SVG) y el
// compositor de export (composite, canvas 2D). Los puntos son fracciones 0..1 del
// bounding box; se mapean al tamaño real en cada motor. Así una forma nueva se
// define UNA vez y sale igual en pantalla y en el PNG.

import type { ShapeKind } from '../scene/types';

/** Radio dejando un pequeño margen para que el trazo no se corte en el borde. */
const R = 0.47;

function regular(sides: number, rotDeg = -90): [number, number][] {
  const pts: [number, number][] = [];
  for (let i = 0; i < sides; i++) {
    const a = ((rotDeg + (360 / sides) * i) * Math.PI) / 180;
    pts.push([0.5 + R * Math.cos(a), 0.5 + R * Math.sin(a)]);
  }
  return pts;
}

function star(spikes: number, innerRatio: number, rotDeg = -90): [number, number][] {
  const pts: [number, number][] = [];
  for (let i = 0; i < spikes * 2; i++) {
    const r = i % 2 === 0 ? R : R * innerRatio;
    const a = ((rotDeg + (180 / spikes) * i) * Math.PI) / 180;
    pts.push([0.5 + r * Math.cos(a), 0.5 + r * Math.sin(a)]);
  }
  return pts;
}

/**
 * Puntos del polígono (x,y en 0..1) o `null` si la forma tiene render propio:
 * rect (div redondeable), circle (elipse), line (trazo). El resto son polígonos
 * rellenables (triángulo, pentágono, hexágono, estrella, flecha de bloque).
 */
export function polyPoints(kind: ShapeKind): [number, number][] | null {
  switch (kind) {
    case 'triangle':
      return [
        [0.5, 0.03],
        [0.97, 0.97],
        [0.03, 0.97],
      ];
    case 'pentagon':
      return regular(5);
    case 'hexagon':
      return regular(6);
    case 'star':
      return star(5, 0.45);
    case 'arrow':
      return [
        [0.02, 0.34],
        [0.6, 0.34],
        [0.6, 0.13],
        [0.98, 0.5],
        [0.6, 0.87],
        [0.6, 0.66],
        [0.02, 0.66],
      ];
    default:
      return null; // rect, circle, line
  }
}

/** Formas cuyo relleno es un polígono (para el toolbar: muestran redondeo NO). */
export function isPolygon(kind: ShapeKind): boolean {
  return polyPoints(kind) !== null;
}
